/**
 * Converts Camel, Pascal/Class, Snake, and Kebab cases to camelCase
 */
export const toCamel = (str: string) =>
  str
    // Remove Pascal Case Beginnings: FOObar -> foobar
    .replace(/^[A-Z]+/, ($1) => $1.toLowerCase())
    // Replace _, - and the following character with only the uppercase following character:
    // foo-bar -> fooBar AND foo_bar -> fooBar
    .replace(/[_-][a-z]/gi, ($1) => $1.charAt(1).toUpperCase())
    // Replace multi-char uppercase with only the first char uppercase: baseURL -> baseUrl
    .replace(/[A-Z]{2,}/g, ($1) => $1.charAt(0) + $1.substring(1).toLowerCase());

/**
 * Converts Camel, Pascal/Class, Snake, and Kebab cases to PascalCase
 */
export const toPascal = (str: string) =>
  str
    // Replace _, - and the following character with only the uppercase following character:
    // foo-bar -> fooBar AND foo_bar -> fooBar
    .replace(/[_-][a-z]/gi, ($1) => $1.charAt(1).toUpperCase())
    // Ensure first character is capitalized
    .replace(/^./, ($1) => $1.toUpperCase());

/**
 * Converts Camel, Pascal/Class, and Kebab cases to snake_case
 */
export const toSnake = (str: string) =>
  str
    // Remove Pascal Case Beginnings: FOObar -> foobar
    .replace(/^[A-Z]+/, ($1) => $1.toLowerCase())
    // Replace all remaining uppercase character groups with lowercase and _ prefix:
    // fooBAR -> foo_bar AND fizzBuzz -> fizz_buzz
    .replace(/[A-Z]+/g, ($1) => `_${$1.toLowerCase()}`)
    // Replace -, and any double __ with: _
    .replace(/[-_]+/g, "_");

export const truncateWithEllipsis = (string: string, maxLength: number): string => {
  return string.length > maxLength // if string is greater than maxLength
    ? `${string.substring(0, maxLength)}...` // we will cut and add an ellipse at max length
    : string; // or return input
};

export const toCurrency = (
  value: string | number,
  { locales, currency }: { locales: string | string[]; currency: string },
) => {
  return Intl.NumberFormat(locales, { style: "currency", currency }).format(Number(value));
};

/**
 * Converts Hashtags to lowercase and removes unwanted characters
 */
export const cleanHashtag = (hashtag: string) => hashtag.toLocaleLowerCase().replace(/[^a-zA-Z0-9]/g, "");

export const toCompactNumber = (number: number) =>
  Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  }).format(number);
